import React from 'react';
import PropTypes from 'prop-types';

import PolicyTemplates from 'components/Managers/Policy/PolicyTemplates/Index';

export default function ChoosePolicyTemplate({ policyEnabled, showCurrency }) {
  return (
    <PolicyTemplates policyEnabled={policyEnabled} showCurrency={showCurrency} />
  );
}

ChoosePolicyTemplate.propTypes = {
  policyEnabled: PropTypes.bool,
  showCurrency: PropTypes.bool,
};

ChoosePolicyTemplate.defaultProps = {
  policyEnabled: true,
  showCurrency: false,
};
